<template>
<content-div>
    
  <div class="contArea">
    <div class="midBox">
      <div class="confirmBox">
        <strong class="tit">
          현재 BMW ServiceCare+ 은<br>
          BMW Plus App에서만 사용 가능합니다.
        </strong>

        <button-app-download></button-app-download>

      </div>
    </div>
  </div>

</content-div>
</template>

<script>
import ButtonAppDownload from '@/components/Button/ButtonAppDownload.vue'
export default {
  components:{
    ButtonAppDownload,
  }
};
</script>